var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eaf6ff",
    d: "M256 263.81c64.29 0 116.7-52.44 116.7-116.7 0-64.29-52.41-116.7-116.7-116.7-64.26 0-116.7 52.41-116.7 116.7 0 64.26 52.44 116.7 116.7 116.7z",
    "data-original": "#eaf6ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0593fc",
    d: "M256 174.38c33.82 0 62.33 27.67 70.98 65.37-19.64 15.08-44.28 24.07-70.98 24.07s-51.31-8.99-70.98-24.07c8.67-37.71 37.16-65.37 70.98-65.37zM256 96.85c19.5 0 35.32 15.82 35.32 35.32S275.5 167.49 256 167.49s-35.29-15.82-35.29-35.32S236.5 96.85 256 96.85z",
    "data-original": "#0593fc",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec7cf",
    d: "M453.63 198.02c6.63 1.5 12.81 4.11 18.4 7.6l4.9-2.49 7.85-4 6.24 6.24 6.24 6.24-4 7.85-2.49 4.93a58.805 58.805 0 0 1 7.63 18.37l5.22 1.7 8.39 2.72v17.66l-8.39 2.72-5.22 1.7c-1.5 6.6-4.11 12.81-7.63 18.37l2.49 4.9 4 7.88-6.24 6.24-6.24 6.24-7.85-4-4.9-2.52a59.11 59.11 0 0 1-18.4 7.63l-1.7 5.24-2.72 8.39h-17.64l-2.75-8.39-1.7-5.24c-6.6-1.5-12.78-4.11-18.37-7.63l-4.9 2.52-7.88 4-6.24-6.24-6.24-6.24 4.02-7.88 2.49-4.9a58.805 58.805 0 0 1-7.63-18.37l-5.24-1.7-8.39-2.72v-17.66l8.39-2.72 5.24-1.7c1.5-6.6 4.11-12.81 7.63-18.37l-2.49-4.93-4.02-7.85 6.24-6.24 6.24-6.24 7.88 4 4.9 2.49a59.666 59.666 0 0 1 18.37-7.6l1.7-5.24 2.75-8.39h17.64l2.72 8.39z",
    "data-original": "#bec7cf",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaf6ff",
    d: "M440.39 228.94c14.94 0 27.04 12.1 27.04 27.04s-12.1 27.04-27.04 27.04-27.04-12.1-27.04-27.04c0-14.93 12.11-27.04 27.04-27.04z",
    "data-original": "#eaf6ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bec7cf",
    d: "M84.87 198.02c6.6 1.5 12.81 4.11 18.4 7.6l4.9-2.49 7.85-4 6.24 6.24 6.24 6.24-4 7.85-2.49 4.93a60.262 60.262 0 0 1 7.63 18.37l5.22 1.7 8.39 2.72v17.66l-8.39 2.72-5.24 1.7c-1.5 6.6-4.11 12.81-7.6 18.37l2.49 4.9 4 7.88-6.24 6.24-6.24 6.24-7.85-4-4.9-2.52a59.41 59.41 0 0 1-18.4 7.63l-1.7 5.24-2.72 8.39H62.8l-2.72-8.39-1.7-5.24c-6.6-1.5-12.81-4.11-18.37-7.63l-4.9 2.52-7.88 4-6.24-6.24-6.24-6.24 4-7.88 2.52-4.9a59.043 59.043 0 0 1-7.63-18.37l-5.24-1.7-8.4-2.73v-17.66l8.39-2.72 5.24-1.7c1.5-6.6 4.11-12.81 7.63-18.37l-2.52-4.93-4-7.85 6.24-6.24 6.24-6.24 7.88 4 4.9 2.49a59.464 59.464 0 0 1 18.37-7.6l1.7-5.24 2.72-8.39h17.66l2.72 8.39z",
    "data-original": "#bec7cf",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eaf6ff",
    d: "M71.63 228.94c14.94 0 27.04 12.1 27.04 27.04s-12.1 27.04-27.04 27.04-27.04-12.1-27.04-27.04c0-14.93 12.11-27.04 27.04-27.04z",
    "data-original": "#eaf6ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d3dde6",
    d: "M256 30.4c3.54 0 7.03.17 10.46.48-59.56 5.27-106.24 55.28-106.24 116.22 0 29.79 11.17 56.95 29.51 77.56l-4.71 15.08c-27.78-21.34-45.72-41.56-45.72-92.64C139.3 96 191.57 30.4 256 30.4z",
    "data-original": "#d3dde6",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0584e3",
    d: "M189.73 224.66c19.22 21.57 46.29 35.97 76.73 38.66-3.49.31-6.97.48-10.46.48-25.71 0-50.49-8.39-70.89-24.04l-.08-.03c1.21-5.23 2.8-10.25 4.7-15.07z",
    "data-original": "#0584e3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbd80",
    d: "M182.44 317.92c7.03-3.52 15.08-1.93 19.13 5.13l20.66 35.77V239.9c0-7.71 6.29-14 14-14s14 6.29 14 14v36.6c0-7.68 6.29-14 14-14s14 6.32 14 14v17.21c0-7.71 6.29-14 14-14s14 6.29 14 14v12.42c0-7.71 6.29-14 14-14s14 6.29 14 14v90.62c0 6.89-1.16 12.78-3.8 19.13l-11.14 27.1v20.47H222.2V428.3c0-9.21-2.13-17.15-6.75-25.11l-38.18-66.13c-3.81-6.69-1.49-15.28 5.17-19.14z",
    "data-original": "#fbbd80",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e2aa73",
    d: "M222.24 339.38v-99.47c0-7.71 6.29-14 14-14 1.98 0 3.88.42 5.61 1.19-4.93 2.15-8.39 7.12-8.39 12.81v118.92zM182.44 317.92c4.25-2.13 8.87-2.38 12.78-.68-.54.2-1.05.43-1.56.68-6.66 3.85-8.99 12.44-5.13 19.13l38.18 66.13c4.62 7.97 6.75 15.9 6.75 25.11v14.68h-11.23V428.3c0-9.21-2.13-17.15-6.75-25.11l-38.18-66.13c-3.84-6.69-1.52-15.28 5.14-19.14z",
    "data-original": "#e2aa73",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0593fc",
    d: "M208.8 442.99h123.93c2.1 0 3.83 1.73 3.83 3.83v30.95c0 2.1-1.73 3.83-3.83 3.83H208.8c-2.1 0-3.83-1.73-3.83-3.83v-30.95c.01-2.1 1.74-3.83 3.83-3.83z",
    "data-original": "#0593fc",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0584e3",
    d: "M208.8 442.99h11.62c-2.1 0-3.83 1.73-3.83 3.83v30.95c0 2.1 1.73 3.83 3.83 3.83H208.8c-2.1 0-3.83-1.73-3.83-3.83v-30.95c.01-2.1 1.74-3.83 3.83-3.83z",
    "data-original": "#0584e3",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#abb3ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.56 202.52a59.53 59.53 0 0 1 12.81-4.51l1.7-5.24 2.72-8.39h11.62l-2.72 8.39-1.7 5.24c-6.6 1.5-12.81 4.11-18.37 7.6l-4.93-2.49zM34.93 308.97l-7.71 3.91-6.24-6.24-6.24-6.24 4-7.88 2.52-4.9a59.043 59.043 0 0 1-7.63-18.37l-5.24-1.7L0 264.83v-17.66l8.39-2.72 5.24-1.7c1.5-6.6 4.11-12.81 7.63-18.37l-2.52-4.93-4-7.85 6.24-6.24 6.24-6.24 7.71 3.91-2.32 2.32-6.24 6.24 4 7.85 2.49 4.93a59.464 59.464 0 0 0-7.6 18.37l-5.24 1.7-8.39 2.72v17.66l8.39 2.72 5.24 1.7c1.5 6.6 4.11 12.81 7.6 18.37l-2.49 4.9-4 7.88 6.24 6.24zM74.41 327.62H62.79l-2.72-8.39-1.7-5.24a57.85 57.85 0 0 1-12.81-4.54l1.13-.57 4.93-2.52a59.043 59.043 0 0 0 18.37 7.63l1.7 5.24z",
    fill: "#abb3ba",
    "data-original": "#abb3ba",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#d3dde6",
    d: "M71.63 228.94c1.5 0 3 .14 4.45.37-12.81 2.13-22.59 13.27-22.59 26.67 0 13.44 9.78 24.58 22.59 26.67-1.45.26-2.95.37-4.45.37-14.94 0-27.04-12.1-27.04-27.04 0-14.93 12.11-27.04 27.04-27.04zM440.39 228.94c1.5 0 3 .14 4.45.37-12.81 2.13-22.59 13.27-22.59 26.67 0 13.44 9.78 24.58 22.59 26.67-1.45.26-2.95.37-4.45.37-14.94 0-27.04-12.1-27.04-27.04 0-14.93 12.11-27.04 27.04-27.04z",
    "data-original": "#d3dde6",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#abb3ba",
    d: "M414.32 202.52a59.34 59.34 0 0 1 12.81-4.51l1.7-5.24 2.75-8.39h11.6l-2.72 8.39-1.7 5.24c-6.6 1.5-12.81 4.11-18.37 7.6l-4.93-2.49zM403.69 308.97l-7.71 3.91-6.24-6.24-6.24-6.24 4.02-7.88 2.49-4.9a58.805 58.805 0 0 1-7.63-18.37l-5.24-1.7-8.39-2.72v-17.66l8.39-2.72 5.24-1.7c1.5-6.6 4.11-12.81 7.63-18.37l-2.49-4.93-4.02-7.85 6.24-6.24 6.24-6.24 7.71 3.91-2.32 2.32-6.24 6.24 4 7.85 2.52 4.93a58.805 58.805 0 0 0-7.63 18.37l-5.24 1.7-8.39 2.72v17.66l8.39 2.72 5.24 1.7c1.5 6.6 4.11 12.81 7.63 18.37l-2.52 4.9-4 7.88 6.24 6.24zM443.17 327.62h-11.6l-2.75-8.39-1.7-5.24a57.85 57.85 0 0 1-12.81-4.54l1.13-.57 4.93-2.52a59.043 59.043 0 0 0 18.37 7.63l1.7 5.24z",
    "data-original": "#abb3ba",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignIcon);
export default __webpack_public_path__ + "static/media/assignIcon.ac5b47af0c7ff2036bcb71ceaedfd5e4.svg";
export { ForwardRef as ReactComponent };